import {IMultiformDictionary} from '@/modules/multiForm/shared/IMultiformDictionary';
import {CountryCode} from 'libphonenumber-js';

export enum Languages{
  ENGLISH = 'english',
  GERMAN = 'german',
  UKRAINIAN = 'ukrainian',
}

export const LanguageCountryCodes: Record<Languages, CountryCode> = {
  [Languages.ENGLISH]: 'GB',
  [Languages.GERMAN]: 'DE',
  [Languages.UKRAINIAN]: 'UA',
};

export const LanguagesDictionary: IMultiformDictionary<Languages> = [
  {
    type: Languages.ENGLISH,
    name_pl: 'Angielski',
  },
  {
    type: Languages.GERMAN,
    name_pl: 'Niemiecki',
  },
  {
    type: Languages.UKRAINIAN,
    name_pl: 'Ukraiński',
  },
];
